import type { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/organizationContacts${`?type=${OrganizationNotificationType}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/organizationContacts`;

export const URL = (type: OrganizationNotificationType): RouteDefinition => `${baseRoute}/organizationContacts?type=${type}`;
